// extracted by mini-css-extract-plugin
export var button = "_f-0";
export var buttonContent = "_f-e";
export var buttonGroup = "_f-c";
export var dontRestrainIconWidth = "_f-a";
export var dropdownButton = "_f-b";
export var iconContainer = "_f-9";
export var lg = "_f-4";
export var md = "_f-3";
export var pending = "_f-f";
export var sm = "_f-2";
export var spinner = "_f-d";
export var squared = "_f-8";
export var wrapText = "_f-g";
export var xl = "_f-5";
export var xs = "_f-1";
export var xxl = "_f-6";
export var xxxl = "_f-7";